import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        {/* <a href="https://github.com/PRADAT3" target="_blank" rel="noreferrer"><GitHubIcon/></a> */}
        <a href="mailto:mathury@purdue.edu" target="_blank" rel="noreferrer"><EmailIcon /></a>
        <a href="https://www.linkedin.com/in/mathur-yash/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
      </div>
      <p>A portfolio built by Yash with 💜</p>
    </footer>
  );
}

export default Footer;